import { supabase } from "@/integrations/supabase/client";

export async function fetchReturningAttendeeIds(
  organizationId: string,
  personIds: string[]
): Promise<Set<string>> {
  const uniqueIds = Array.from(new Set(personIds)).filter(Boolean);
  if (!organizationId || uniqueIds.length === 0) {
    return new Set();
  }

  const { data, error } = await supabase
    .from("attendance")
    .select("person_id")
    .eq("organization_id", organizationId)
    .in("person_id", uniqueIds);

  if (error) throw error;
  return new Set((data || []).map((row) => row.person_id));
}
